import DraftsRoute from 'cio/pods/base/overview/drafts/index/route';

export default class IndexRoute extends DraftsRoute {
  model() {
    return this.modelFor('campaigns.campaign');
  }
}
